module.exports = __webpack_public_path__ + "img/left_qb.74988742.svg";